import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { InteractionDetailResponseData } from "../../types/interaction";

export const getData = async (
  id: string | undefined,
): Promise<InteractionDetailResponseData> => {
  const { data } = await api.get(`/interactions/${id}`);

  return data;
};

export const useInteraction = (
  id: string | undefined,
): QueryObserverBaseResult<InteractionDetailResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.interaction(id),
    () => getData(id),
    { enabled: Boolean(id) },
  );
  return { data, ...props };
};
